import { FC } from 'react';
import Chart from '../Cards/Chart';
import Chess from '../Cards/Chess';
import Puzzle from '../Cards/Puzzle';
import Roboarm from '../Cards/Roboarm';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { productName } = ApplicationDomainUtility;

const StrategyTool: FC = () => {
  return (
    <div className="strategy-tools">
      <h2>
        Your Complete<span> Strategy Toolkit</span>
      </h2>
      <div className="content">
        <Chess productName={productName} />
        <Roboarm productName={productName} />
        <Puzzle productName={productName} />
        <Chart productName={productName} />
      </div>
    </div>
  );
};

export default StrategyTool;
